<template>
  <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">源码 下载</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="mt-6">
              <v-col cols="12" >
                <v-text-field
                :rules="nameRules"
                label="姓名*"
                v-model="formData.name"
                :counter="20"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                :rules=phoneRules
                :counter="11"
                type="number"
                label="手机号*"
                v-model="formData.contact"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :rules=emailRules
                  label="邮箱*"
                  v-model="formData.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark  @click="hiddenDialog">取消</v-btn>
          <v-btn color="success" :disabled="!valid"  @click="apply">申请</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="popDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{popTitle}}</v-card-title>
          <v-card-text>{{popText}}</v-card-text>
          <v-card-actions>
            <v-col cols="12">
              <v-row
                :align="alignment"
                :justify="justify">
                <v-btn  outlined elevation="3" color="success" @click="define">确定</v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-form>
</template>
<style></style>
<script>
  export default {
    name: 'download',
    data: () => ({
      popDialog:false,
      popTitle:'',
      popText:'',
      alignment: 'center',
      justify: 'center',
      formData: {
        name: '',
        contact: '',
        email: '',
      },
      valid:true,
      rules: {
        required: value => !!value || '请输入'
      },
      emailRules: [
        v => !!v || '邮箱必填',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || '姓名必填',
        v => v && v.length <= 20 || '姓名请填写20个字符以内',
      ],
      phoneRules: [
        v => !!v || '手机号必填',
        v => v && v.length == 11 || '手机号必须11位',
      ],
    }),
    methods:{
      define(){
        this.popDialog = false;
      },
      hiddenDialog(){
        this.$emit('childHidden', this.formData)
        this.$refs.form.reset()
      },
      apply(){
        this.$api.askForCode.askForCode(this.formData).then((res)=>{
          this.popText = '工程正在打包中,预计24小时将发送到你的邮箱内,敬请期待~';
          this.popDialog = true;
          this.$refs.form.reset();
          this.hiddenDialog();
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/page/index/download.vue